import { Entry } from 'contentful';

import { TypeUsRegionSkeleton } from '../../../../interfaces/contentful';

interface IProps {
  regionList?:
    | (Entry<TypeUsRegionSkeleton, 'WITHOUT_UNRESOLVABLE_LINKS'> | undefined)[]
    | undefined;
  regionId?: string;
}

export const getCurrentRegion = ({
  regionList,
  regionId,
}: IProps): Entry<TypeUsRegionSkeleton, 'WITHOUT_UNRESOLVABLE_LINKS'> | undefined => {
  if (!regionList || !regionId) {
    return undefined;
  }
  const selectedRegion = regionList.find(r => r?.fields.regionCode === regionId);
  return selectedRegion;
};
